export default "__VITE_ASSET__BFCcFANS__"